import React, { useRef, useState } from "react";
import { ManualBox } from "../manualsBox/products-manualsBox";
export const tabList = [
    {idx: 1, title : 'Features'},
    {idx: 2, title : 'Description'},
    {idx: 4, title : 'Specifications'},
    {idx: 5, title : 'Manuals & Firmware'},
]
export const GX9000 = () => {
    const [state, setState] = useState<any>({first : 1, second : 1})
    const [tabIndex, setTabIndex] = useState<number>(1)
    const scrollRef = [
        useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null),
        useRef<any>(null),
        useRef<any>(null),
        useRef<any>(null),
        useRef<any>(null),
        useRef<any>(null)
    ];
    const handleScroll = (ref : number) => {
        if(scrollRef[ref] && scrollRef[ref].current){
            scrollRef[ref].current.scrollIntoView({
                behavior : 'smooth'
            })
        }
    }
    return(
      <>
          <div className="product_view gx1600">
              <div className="bgBox" style={{backgroundImage: "url('/assets/images/product/gx9000/banner_GX9000.png')"}}>
                  <div className="centerBox">
                      <h2><span>GX</span>9000</h2>
                      <p>See Now on Screen. Keep it in QHD</p>
                      <ul>
                          <li onClick={() => handleScroll(0)}>QHD / FHD</li>
                          <li onClick={() => handleScroll(1)}>Auto Super Night Vision 2.0</li>
                          <li onClick={() => handleScroll(2)}>Sony STARVIS Sensor</li>
                          <li onClick={() => handleScroll(3)}>HDR</li>
                          <li onClick={() => handleScroll(4)}>FineVu Cloud & Wi-Fi App</li>
                          <li onClick={() => handleScroll(5)}>Smart Time-Lapse</li>
                          <li onClick={() => handleScroll(6)}>ADAS Plus</li>
                          <li onClick={() => handleScroll(7)}>Plate Readability 2.0</li>
                          <li onClick={() => handleScroll(8)}>AI Heat Monitoring</li>
                          <li onClick={() => handleScroll(9)}>Power Saving Parking Mode</li>
                          <li onClick={() => handleScroll(10)}>Speed Camera Alert</li>
                          <li onClick={() => handleScroll(11)}>Low Voltage Cut-Off</li>
                          <li onClick={() => handleScroll(12)}>Memory Allocation</li>
                          <li onClick={() => handleScroll(13)}>Format Free 2.0</li>
                          <li onClick={() => handleScroll(14)}>Customizing OSD Phrases</li>
                      </ul>
                  </div>

                  <div className="scrollDownBox">
                      <div>
                          <span></span>
                      </div>
                      <span>SCROLL</span>
                  </div>
              </div>
              {/* <!-- bgBox Fin --> */}

              <div className="tabWrap tabBtnWrapBattery">
                  <div className="tabBtnWrap">
                      <div className="tabBtnBox">
                          {tabList.map((list: { idx: number, title: string }) => (

                            <button className={tabIndex === list?.idx ? 'active' : ''} onClick={() => setTabIndex(list?.idx)}>
                                {list?.title}
                            </button>
                          ))}
                      </div>
                  </div>
                  <div className="tabContentBox">
                      <div className={`features ${tabIndex === 1 ? 'active' : ''}`}>
                          <section className="section_1">
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_01.png" alt="GX1600"/>
                              </div>
                          </section>

                          <div className="iconBox2">
                              <ul>
                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_01.png" alt="UHD/FHD"/>
                                      </div>
                                      <span>QHD/FHD</span>
                                  </li>
                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_02.png" alt="SONY STARVIS Sensor"/>
                                      </div>
                                      <span>
                        AUTO<br/>
                        NIGHT VISION
                    </span>
                                  </li>
                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_03.png" alt="TIME LAPSE"/>
                                      </div>
                                      <span>SONY STARVIS<br/> SENSOR</span>
                                  </li>
                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_04.png" alt="BUILT-IN GPS & WI-FI"/>
                                      </div>
                                      <span>HDR</span>
                                  </li>
                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_05.png" alt="FINEVU CLOUD & WI-FI APP"/>
                                      </div>
                                      <span>FINEVU CLOUD<br/> & WI-FI APP</span>
                                  </li>

                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_06.png" alt="CUSTOMIZING OSD PHRASES"/>
                                      </div>
                                      <span>SMART<br/> TIME-LAPSE</span>
                                  </li>
                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_07.png" alt="Auto Night Vision"/>
                                      </div>
                                      <span>ADAS PLUS</span>
                                  </li>
                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_08.png" alt="ADAS PLUS"/>
                                      </div>
                                      <span>PLATE<br/> READYBILITY 2.0</span>
                                  </li>
                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_09.png" alt="NON-LCD"/>
                                      </div>
                                      <span>AI HEAT<br/> MONITORING</span>
                                  </li>
                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_10.png" alt="SPEED CAMERA ALERT"/>
                                      </div>
                                      <span>POWER SAVING<br/> PARKING MODE</span>
                                  </li>
                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_11.png" alt="POWER SAVING PARKING MODE"/>
                                      </div>
                                      <span>SPEED CAMERA<br/> ALERT</span>
                                  </li>
                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_12.png" alt="AI HEAT MONITORING"/>
                                      </div>
                                      <span>LOW VOLTAGE<br/> CUT-OFF</span>
                                  </li>
                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_13.png" alt="LOW VOLTAGE CUT-OFF"/>
                                      </div>
                                      <span>MEMORY <br/>ALLOCATION</span>
                                  </li>
                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_14.png" alt="MEMORY ALLOCATION"/>
                                      </div>
                                      <span>FORMAT <br/>FREE 2.0</span>
                                  </li>
                                  <li>
                                      <div>
                                          <img src="/assets/images/product/gx9000/FineVu_GX9000_icon_15.png" alt="FORMAT FREE 2.0"/>
                                      </div>
                                      <span>CUSTOMIZING OSD <br/>PHRASES</span>
                                  </li>
                              </ul>
                          </div>

                          <section className="section_2" ref={scrollRef[0]}>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_02.png" alt="UHD/QHD"/>
                              </div>
                              <div className="resolution_tableWrap" style={{marginTop: '30px'}}>
                                  <ul>
                                      <li>
                                          <span></span>
                                          <span>FHD</span>
                                          <span>QHD</span>
                                      </li>
                                      <li>
                                          <span>Resolution</span>
                                          <span>1920 x 1080</span>
                                          <span style={{borderBottom: '1px solid #F0800E'}}>2560 x 1440</span>
                                      </li>
                                      <li>
                                          <span>Pixels</span>
                                          <span>2,073,600</span>
                                          <span style={{borderRight: '1px solid #F0800E', borderBottom: '1px solid #F0800E'}}>3,686,400</span>
                                      </li>
                                  </ul>
                              </div>
                          </section>

                          <section className="section_3">
                              <div className="imgBox" style={{marginBottom: '10px'}}>
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_03.png" alt="UHD/QHD"/>
                              </div>
                              <p>*This footage was recorded in QHD/FHD resolution. The license plate was mosaicized to protect personal information.</p>
                              <p>*The quality of recording may vary depending on conditions. (including camera angle, windshield conditions, and light conditions)</p>
                          </section>

                          <section className="section_4" ref={scrollRef[1]}>
                              <h3>
                                  <span>AUTO SUPER NIGHT VISION 2.0</span>
                                  BRIGHT AND CLEAR FOOTAGE EVEN AT NIGHT
                              </h3>
                              <p>Records brighter, clearer nighttime video while reducing image degradation in low-light scenes.</p>
                              <div className="imgBox" style={{marginBottom: '40px'}}>
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_04.png" alt="AUTO SUPER NIGHT VISION"/>
                              </div>
                              <p>*This footage was recorded in QHD/FHD resolution. The license plate was mosaicized to protect personal information.</p>
                              <p>*The quality of recording may vary depending on conditions. (including camera angle, windshield conditions, and light conditions)</p>
                          </section>

                          <section className="section_4" ref={scrollRef[2]}>
                              <h3>
                                  <span>SONY STARVIS SENSOR</span>
                                  CLEAR RECORDING EVEN AT NIGHT
                              </h3>
                              <p>SONY STARVIS SENSOR provides remarkably vivid and clear images, regardless of day or night.</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_05.png" alt="ADAS MAX"/>
                              </div>
                          </section>

                          <section className="section_5" ref={scrollRef[3]}>
                              <h3>
                                  <span>HDR</span>
                                  OPTIMIZED WITH HIGH DYNAMIC RANGE(HDR)
                              </h3>
                              <p>Exposure is balanced for keeping all details intact.</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_06.png" alt="DUAL HDR"/>
                              </div>
                          </section>

                          <section className="section_6">
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_07.png" alt="TIME Lapse"/>
                              </div>
                          </section>

                          <section className="section_7">
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_08.png" alt="TIME Lapse"/>
                              </div>
                          </section>

                          <section className="section_8" ref={scrollRef[4]}>
                              <h3>
                                  <span>built-in bt + wi-fi</span>
                                  SEAMLESSLY CONNECT TO<br/>
                                  YOUR SMARTPHONE WITH JUST ONE TOUCH
                              </h3>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_09.png" alt="TIME Lapse"/>
                              </div>
                              <p style={{marginTop: '20px'}}>*If the connection fails, please allow all FineVu CLOUD & Wi-Fi app permissions.</p>
                          </section>

                          <div className="resolution_tableWrap">
                              <ul>
                                  <li>
                                      <span></span>
                                      <span>Wi-Fi</span>
                                      <span>BT + Wi-Fi</span>
                                  </li>
                                  <li>
                                      <span>DAY 1<br/><span style={{fontSize: '14px', color: '#666'}}>First Connection</span></span>
                                      <span><img src="/assets/images/product/gx9000/FineVu_GX9000_10.png" alt="WI-FI"/></span>
                                      <span style={{borderBottom: '1px solid #F0800E'}}><img src="/assets/images/product/gx9000/FineVu_GX9000_11.png" alt="built-in bt + WI-FI"/></span>
                                  </li>
                                  <li>
                                      <span>DAY 2</span>
                                      <span><img src="/assets/images/product/gx9000/FineVu_GX9000_12.png" alt="WI-FI"/></span>
                                      <span style={{borderRight: '1px solid #F0800E', borderBottom: '1px solid #F0800E'}}><img src="/assets/images/product/gx9000/FineVu_GX9000_13.png" alt="built-in bt + WI-FI"/></span>
                                  </li>
                                  <li>
                                      <span>DAY 3</span>
                                      <span><img src="/assets/images/product/gx9000/FineVu_GX9000_14.png" alt="WI-FI"/></span>
                                      <span><img src="/assets/images/product/gx9000/FineVu_GX9000_15.png" alt="built-in bt + WI-FI"/></span>
                                  </li>
                              </ul>
                          </div>

                          <section className="section_9">
                              <h3>
                                  CHECK THE RECORDED VIDEOS AND UPDATE<br/>
                                  THE FIRMWARE ON FINEVE APP.
                              </h3>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_31.png" alt="APP QR Code"/>
                              </div>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_16.png" alt="APP"/>
                              </div>
                          </section>

                          <section className="section_10" ref={scrollRef[5]}>
                              <h3>
                                  <span>smart time-lapse</span>
                                  RECORD YOUR DRIVE WITH TIME-LAPSE
                              </h3>
                              <p>SMART TIME-LAPSE feature captures up to 572minutes with no data loss.</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_17.png" alt="APP"/>
                              </div>
                              <ul>
                                  <li>* SMART TIME-LAPSE Specifications were measured under 32GB and compared to the default driving mode.</li>
                                  <li>* Factors such as collision events may affect the storage volume.</li>
                              </ul>
                          </section>


                          <section className="section_11" ref={scrollRef[6]}>
                              <h3>
                                  <span>ADAS PLUS</span>
                                  ADVANCED DRIVER SAFETY WARNING SYSTEMS<br/>
                                  KEEP YOU SAFE ON THE ROAD
                              </h3>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_18.png" alt="APP"/>
                              </div>
                          </section>

                          <section className="section_12">
                              <h3>
                                  LANE DEPARTURE WARNING SYSTEM (LDWS)
                              </h3>
                              <p>Alert if triggered as vehicle veers off driving lane while in motion.</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_19.png" alt="APP"/>
                              </div>
                          </section>

                          <section className="section_13">
                              <h3>
                                  FRONT VEHICLE MOTION ALERT (FVMA)
                              </h3>
                              <p>While stopped in traffic, the movement of stationary vehicle ahead triggers alert to driver.</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_20.png" alt="APP"/>
                              </div>
                          </section>

                          <section className="section_14" ref={scrollRef[7]}>
                              <h3>
                                  <span>PLATE READABILITY 2.0</span>
                                  TURN BLURRED NUMBERS INTO CLEAR READS,<br/>
                                  PLATE READBILITY 2.0!
                              </h3>
                              <p>By enhancing license plate recognition in dynamic situations such as vehicle direction changes,<br/>
                                  blurred license plate numbers can be seen more clearly.</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_21.png" alt="APP"/>
                              </div>
                              <ul style={{marginTop: '30px'}}>
                                  <li>*Actual recording quality may differ depending on usage conditions, including window tint, camera angle, windshield condition, lighting, and weather.</li>
                                  <li>*PLATE READABILITY 2.0 is available only in Driving Mode and is not compatible with HDR simultaneously.</li>
                              </ul>
                          </section>

                          <section className="section_15" ref={scrollRef[8]}>
                              <h3>
                                  <span>Ai heat monitoring</span>
                                  SMART AI DASHCAM CONTROL
                              </h3>
                              <p>If FineVu starts to overheat while at parking mode, the AI will automatically switch it to Power Saving Parking Mode.<br/>
                                  When it cools down and temperature stabilizes, AI will switch it back to motion parking mode.</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_22.png" alt="APP"/>
                              </div>
                              <p style={{marginTop: '30px'}}>
                                  * The feature is only applicable during motion/time lapse parking mode.
                              </p>
                          </section>

                          <section className="section_16" ref={scrollRef[9]}>
                              <h3>
                                  <span>power saving parking mode</span>
                                  PROLONGED RECORDING TIME
                              </h3>
                              <p>Consuming 98% less power, GX36 records 2,325 more hours than standard parking mode.</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_23.png" alt="APP"/>
                              </div>
                              <div className="resolution_tableWrap" style={{marginTop: '30px'}}>
                                  <ul>
                                      <li>
                                          <span></span>
                                          <span>Parking Mode (motion)</span>
                                          <span>Power Saving Parking Mode</span>
                                      </li>
                                      <li>
                                          <span>Power consumption</span>
                                          <span>4.8 W</span>
                                          <span style={{borderBottom: '1px solid #F0800E'}}>0.06 W</span>
                                      </li>
                                      <li>
                                          <span>Parking Mode Duration</span>
                                          <span>29 hours</span>
                                          <span style={{borderRight: '1px solid #F0800E', borderBottom: '1px solid #F0800E'}}>2,325 hours</span>
                                      </li>
                                  </ul>
                              </div>
                          </section>

                          <section className="section_17" ref={scrollRef[10]}>
                              <h3>
                                  <span>speed camera alert</span>
                                  FINEVU KEEPS UP WITH THE<br/>
                                  LATEST SAFETY CAMERA ALERT
                              </h3>
                              <p>FineVu safety camera database is always up to date. Download the quarterly updates,<br/>
                                  and get informed with FineVu’s voice alerts.<br/>
                                  Worry no more about accidents and speeding tickets.</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_24.png" alt="APP"/>
                              </div>
                              <p style={{marginTop: '30px'}}>* Database is updated quarterly.</p>
                          </section>

                          <section className="section_18" ref={scrollRef[11]}>
                              <h3>
                                  <span>low voltage cut-off</span>
                                  BATTERY PROTECTION INTEGRATED
                              </h3>
                              <p>FineVu Designed with battery Protection system.<br/>
                                  The dashcam automatically shuts down when the battery level gets too low.<br/>
                                  Choose a power setting optimized for your car. Manage your dashcam and battery effortlessly with a single tap.</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_25.png" alt="APP"/>
                              </div>
                              <p style={{marginTop: '30px'}}>*FineVu recommends changing the low voltage settings to ‘hybrid’ when using the ISG system.</p>
                          </section>

                          <section className="section_18" ref={scrollRef[12]}>
                              <h3>
                                  <span>memory allocation</span>
                                  EFFICIENT MEMORY MANAGMENT
                              </h3>
                              <p>The memory allocation efficiently manages storage based on your driving pattern.</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_26.png" alt="APP"/>
                              </div>
                              <ul style={{marginTop: '30px'}}>
                                  <li>*The MicroSD card is formatted when changing the memory allocation</li>
                                  <li>*The memory format type is FAT32, and if the format type is different, the dash cam proceeds with formatting automatically.<br/>
                                      (After formatting, once you insert it into the device and supply it with power, the formatting will be in progress to set the memory.)
                                  </li>
                              </ul>
                          </section>

                          <section className="section_19" ref={scrollRef[13]}>
                              <h3>
                                  <span>FORMAT FREE 2.0</span>
                                  ADVANCED FORMAT FREE TECHNOLOGY
                              </h3>
                              <p>Format Free 2.0 technology eliminates the needs of manual reformatting the micro SD memory card.<br/>
                                  Also, it helps to extend memory card lifetime and improve reliability.</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_27.png" alt="APP"/>
                              </div>
                          </section>

                          <section className="section_20" ref={scrollRef[14]}>
                              <h3>
                                  <span>CUSTOMIZING OSD PHRASES</span>
                                  SYMBOLIC NAME ACCORDING TO USER’S TASTE
                              </h3>
                              <p>Users can change the wording of the On Screen Display(OSD) to user’s preference.<br/>
                                  Up to 20 characters can be entered in English letters, numbers, and special characters.</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_28.png" alt="APP"/>
                              </div>
                              <ul style={{marginTop: '30px'}}>
                                  <li>* OSD Phrases can be set up in the FineVu CLOUD & Wi-Fi app.</li>
                                  <li>* Special characters are only available for `~!@$^&*()-_=+:;[]&lt;&gt;? (Spaces are not supported.)</li>
                              </ul>
                          </section>

                          <section className="section_21">
                              <h3>
                                  <span>pip mode</span>
                                  VIEW FRONT AND REAR VIEWS AT A GLANCE
                              </h3>
                              <p>Supports Picture-in-Picture (PIP) mode for simultaneous front and rear display.<br/>
                                  Simply tap the screen to switch between front, rear, and PIP views</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_29.png" alt="APP"/>
                              </div>
                          </section>

                          <section className="section_22">
                              <h3>
                                  <span>FINEVU PC PLAYER</span>
                                  THE OPTIMAL DASH CAM ANALYSIS PROGRAM,<br/>
                                  FINEVU PLAYER 2.0
                              </h3>
                              <p>FineVu PC player is an easy-to-use PC software for FineVu dash cam.<br/>
                                  You can playback, screenshot, enlarge the images with full resolution and<br/>
                                  monitor the video records conveniently on your PC.</p>
                              <div className="imgBox">
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_30.png" alt="APP"/>
                              </div>
                              <p style={{marginTop: '30px'}}>* This feature can be used after installing FineVu Player program.</p>
                          </section>
                      </div>
                      <div className={`whatsInTheBox ${tabIndex === 2 ? 'active' : ''}`}>
                          <section>

                              <div className="imgBox">
                                  <h3>Product Description</h3>
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_32.png" alt="Product Description"/>
                              </div>
                              <div className="imgBox" style={{marginBottom: '30px'}}>
                                  <h3>WHAT’S IN THE BOX</h3>
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_33.png" alt="Product Description"/>
                              </div>
                              <ul style={{marginBottom: '100px'}}>
                                  <li>※ To improve the performance of the product, its components may change without prior notice.</li>
                                  <li>※ The warranty period of the Micro SD card is 6 months.</li>
                              </ul>
                              <div className="imgBox">
                                  <h3>OPTIONAL ACCESSORIES</h3>
                                  <img src="/assets/images/product/gx9000/FineVu_GX9000_34.png" alt="Product Description"/>
                              </div>
                          </section>
                      </div>

                      <div className={`specifications ${tabIndex === 4 ? 'active' : ''}`}>
                          <div className="tableWrap">
                              <table>
                                  <thead>
                                  <tr>
                                      <th>&nbsp;</th>
                                      <th>FineVu GX9000</th>
                                      <th>Remark</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr>
                                      <th rowSpan={2}>Image Sensor</th>
                                      <td>
                                          5M pixels CMOS Image Sensor (1/2.8")
                                      </td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <td>
                                          2M pixels CMOS Image Sensor (1/2.9")
                                      </td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Resolution</th>
                                      <td>
                                          2560*1440(Quad HD) / 1920*1080P(Full HD)
                                      </td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Frames Per Second</th>
                                      <td>
                                          30fps
                                      </td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Viewing Angle</th>
                                      <td>
                                          Front : 136°<br></br>
                                          Rear : 124.4°
                                      </td>
                                      <td>Diagonal</td>
                                  </tr>
                                  <tr>
                                      <th>Recording Mode</th>
                                      <td>
                                          Driving Recording (Standard, Impact Detection, Smart Time Lapse), Manual Recording, Parking Recording (Motion Detection, Impact Detection, Smart Time Lapse)
                                      </td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Display</th>
                                      <td>3.5inch IPS 800x480</td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Acceleration Sensor</th>
                                      <td>3-axis acceleration Sensor</td>
                                      <td>+2g / -2g</td>
                                  </tr>
                                  <tr>
                                      <th>GPS</th>
                                      <td>External</td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Wi-Fi</th>
                                      <td>Built-in (BT Wi-Fi / 2.4GHz / 5GHz)</td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Storage Capacity</th>
                                      <td>FineVu Micro SD Card (32GB ~ 128GB)</td>
                                      <td>Class 10 or above, SDXC support</td>
                                  </tr>
                                  <tr>
                                      <th>Battery</th>
                                      <td>Super capacitor</td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>MIC</th>
                                      <td>Built-In</td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Speaker</th>
                                      <td>Built-In</td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Interface</th>
                                      <td>
                                          Power port, Rear Camera connection port, Micro SD card slot, GPS connection port, BT + Wi-Fi Dongle port
                                      </td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Security LED</th>
                                      <td>
                                          Front : White / Rear : Blue
                                      </td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Input Power</th>
                                      <td>DC 12V~24V</td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Power Consumption</th>
                                      <td>
                                          Parking Mode : 4.8W / Power Saving Parking Mode : 0.06W
                                      </td>
                                      <td>2CH, GPS OFF / WI-FI OFF</td>
                                  </tr>
                                  <tr>
                                      <th>High-Temperature Cut-Off</th>
                                      <td>AI Heat Monitoring</td>
                                      <td>During parking mode</td>
                                  </tr>
                                  <tr>
                                      <th>Low Voltage Cut-Off</th>
                                      <td>Supported</td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Temperature</th>
                                      <td>
                                          Operation : -10°C ~ 60°C (14°F ~ 140°F)<br/>
                                          Storage : -20°C ~ 70°C (-4°F ~158°F)
                                      </td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Size(WxDxH)</th>
                                      <td>
                                          Front : 101.2 x 60.7 x 27.2mm (4.0 x 2.4 x 1.1”)<br/>
                                          Rear : 46.8 x 27.8 x 36.5mm (1.8 x 1.1 x 1.4”)
                                      </td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Weight</th>
                                      <td>
                                          Front : 102g (3.6oz)<br/>
                                          Rear : 21g (0.7oz)
                                      </td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Language Supported</th>
                                      <td>English, Hebrew, Japanese, Polish, Korean</td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <th>Mobile Application</th>
                                      <td>FineVu CLOUD & Wi-Fi App</td>
                                      <td>Android, iOS</td>
                                  </tr>
                                  <tr>
                                      <th>PC Viewer</th>
                                      <td>FineVu Player 2.0</td>
                                      <td>Windows, MAC</td>
                                  </tr>
                                  <tr>
                                      <th>Features</th>
                                      <td>
                                          HDR, Auto Night Vision, AI Heat Monitoring, Smart Time Lapse, ADAS PLUS (FVMA & LDWS), Speed Camera Alert, Low Voltage Cut-Off, PIP
                                      </td>
                                      <td>ADAS and Speed Camera Alert requires GPS reception</td>
                                  </tr>
                                  <tr>
                                      <th>Certification</th>
                                      <td className="imgArea">
                                          <div>
                                              <img src="/assets/images/table_certification.png" alt="Certification"/>
                                          </div>
                                      </td>
                                      <td></td>
                                  </tr>
                                  </tbody>
                              </table>
                          </div>
                      </div>

                      {tabIndex === 5 ? <ManualBox/> : ''}
                  </div>
              </div>
          </div>

      </>
    )
}
